import { createFileRoute } from '@tanstack/react-router';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { WhatsNewPage } from '@/release-notes/whats-new-page';

export const Route = createFileRoute('/whats-new')({
    component: WhatsNewRoute,
});

// Local wrapper (NOT exported — route files export only Route). See
// routes/privacy.tsx for why the switcher mounts at the route level.
function WhatsNewRoute() {
    return (
        <>
            <CornerLanguageSelector />
            <WhatsNewPage />
        </>
    );
}
